import { Component, Input, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataService } from '../../services/data.service';

@Component({
	selector: 'app-coupons',
	imports: [CommonModule, FormsModule],
	providers: [DatePipe],
	templateUrl: './coupons.component.html',
	styleUrl: './coupons.component.scss',
})
export class CouponsComponent {
	datePipe = inject(DatePipe);
  base = 'coupons';		// important for API calls
	loading = false;
	isEdit = false;
	allData: any = [];
	today = new Date().toISOString().split('T')[0];

	frmDataX: any = {};
  frmData: any = {
    id: null,
		code: '',
		disc_type: '',
		disc_value: 0,
		valid_from: this.today,
		valid_until: this.today,
		max_uses: 0,
		bal_uses: 0,
		is_valid: true
	}

  constructor(public dataService: DataService) {
    //
  }

  ngOnInit() {
		this.loading = true;
    this.dataService.getAllRecords(this.base).then((res: any) => {
      this.allData = res;
      this.loading = false;
    });
	}

  newClick() {
    this.isEdit = false;
		this.resetForm();
  }

  editClick(myData: any) {
    this.isEdit = true;
		this.frmData = Object.assign({}, myData);
		this.frmData.valid_from = myData.valid_from;
		this.frmData.valid_until = myData.valid_until;
  }

	resetForm() {
		this.isEdit = false;
		this.frmData = {
			id: 0,
			code: '',
			disc_type: '',
			disc_value: 0,
			valid_from: this.dataService.ymd2dmy(this.today),
			valid_until: this.dataService.ymd2dmy(this.today),
			max_uses: 0,
			bal_uses: 0,
			is_valid: true
		}
	}

  doSave() {
    this.loading = true;
    this.dataService.addNewRecord(this.base, this.frmData).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
				this.isEdit = false;
        this.resetForm();
				this.ngOnInit();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

  doUpdate() {
    this.loading = true;
		const myid = this.frmData.id;
		delete this.frmData.id;

    this.dataService.updateRecord(this.base, myid, this.frmData).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
				this.isEdit = false;
        this.resetForm();
				this.ngOnInit();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

	async deleteClick(myid: number) {
    const confirmed = await this.dataService.confirmDelete();
    if (confirmed) {
        console.log('Item deleted successfully');
				this.doDelete(myid);
    } else {
        console.log('Deletion cancelled');
    }
	}

  doDelete(myid: number) {
		this.loading = true;
    this.dataService.deleteRecord(this.base, myid).subscribe({
      next: (response) => {
        console.log('Response received in component:', response);
        // You can handle your loading states or form resets here:
        this.loading = false;
        this.ngOnInit();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
	}
}
